module.exports = __webpack_public_path__ + "assets/img/right@2x.753f6254.svg";